export default "__VITE_ASSET__BQV6ZyL$__"